import React, { useRef } from 'react';
import Block from './Block';
import { grabImgSrcs } from 'helpers/content';
import { Helmet } from 'react-helmet';
import { HeroWrapper } from './HeroWrapper';
import { useApplyTrackAssetClickedToLinks } from './HomeHtmlBlock';
import { useSplitTreatment } from 'hooks/splits/useSplitTreatment';

const AU_COMMERCE_HOME_HERO_ID = 'au_commerce_home_hero';
const AU_COMMERCE_HOME_HERO_VARIANT = 'au_commerce_home_hero_variant';
interface HomeHeroBlockProps {
  blur: boolean;
}

const SPLIT_IO_FEATURE_FLAG_HOMEPAGE_PROMO = 'FeatureFlag-EN8509-Homepagepromotemplate';
const SPLIT_IO_FEATURE_FLAG_HOMEPAGE_PROMO_COOKIE = 'au_split_feature_flag_homepage_promo';

export const HomeHeroBlock = ({ blur }: HomeHeroBlockProps): React.JSX.Element => {
  const heroWrapperRef = useRef<HTMLDivElement | null>(null);

  const { treatmentStatus: homepagePromoVariant } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_HOMEPAGE_PROMO,
    SPLIT_IO_FEATURE_FLAG_HOMEPAGE_PROMO_COOKIE
  );

  const shouldDisplayHomePageVariant = homepagePromoVariant ? AU_COMMERCE_HOME_HERO_VARIANT : AU_COMMERCE_HOME_HERO_ID;
  useApplyTrackAssetClickedToLinks(heroWrapperRef, shouldDisplayHomePageVariant);

  return (
    <Block
      // RE: EN-8509 - this conditionally renders the home hero or the home hero variant
      id={shouldDisplayHomePageVariant}
      render={content => {
        // Guidelines for what we can expect in the au_commerce_home_hero block:
        // https://docs.google.com/document/d/14P9mme7g9Is2CnU8VBU2uFK0o7IT8GXYWMosCAyljW8/edit?usp=sharing
        // Parse block content for image src to preload
        // NOTE: This method of preloading only works after building. Developing locally will not preload.
        const imageSrcs = grabImgSrcs(content);
        const mobileImgSrc = imageSrcs?.find(imageSrc => imageSrc?.id === 'mobile-hero')?.src;
        const desktopImgSrc = imageSrcs?.find(imageSrc => imageSrc?.id === 'desktop-hero')?.src;
        return (
          <>
            {desktopImgSrc && (
              <Helmet
                link={[{ rel: 'preload', as: 'image', href: desktopImgSrc, media: 'screen and (min-width: 769px)' }]}
              />
            )}
            {mobileImgSrc && (
              <Helmet
                link={[{ rel: 'preload', as: 'image', href: mobileImgSrc, media: 'not screen and (min-width: 769px)' }]}
              />
            )}
            <HeroWrapper blur={blur} ref={heroWrapperRef} dangerouslySetInnerHTML={{ __html: content }} />
          </>
        );
      }}
    />
  );
};
